module.exports = __webpack_public_path__ + "img/slika1_2022.b2160e19.png";